import { formatCurrency } from '@angular/common';

import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {Cards, OnlineKeyScreenResponseModel, PaginationModel} from './models/Onlinekeys-search.model';

export class Onlinekeys implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  private cards: Cards[] = null;

  constructor(response: OnlineKeyScreenResponseModel) {
    this.title = 'Rabo Online Keys';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.cards = response.detailsViewObject.cards || null;
      this.title = response.detailsViewObject.commercialProductTypeName || 'Rabo Online Keys';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setTables(response);
    }
  }

  public setPanels() {
    this.panels.push(new DetailPanel(this.title));
  }

  public setNameAndValues(response) {
  }

  public addValues(response) {
  }

  private setTables(response: OnlineKeyScreenResponseModel) {
    this.panels[0].hasTable = true;
    this.panels[0].lazyLoadingData =
      new LazyLoadingData(null, null, 'onlinekeysearch');
    this.panels[0].lazyLoadingData.data =
      (response.detailsViewObject && response.detailsViewObject.cards) ? response.detailsViewObject.cards : [];
    this.panels[0].lazyLoadingData.paginationObj = response.paginationObject;
  }

  private createErrorMessage(response: OnlineKeyScreenResponseModel) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

}
